<template>
  <div class="product-banner">
    <div class="product-banner__title">
      <slot name="title">
        {{ title }}
      </slot>
    </div>
    <div class="product-banner__subtitle">
      <slot name="subtitle">
        {{ subtitle }}
      </slot>
    </div>
    <div class="product-banner__info">
      <slot name="info">
        {{ info }}
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProductBanner",
  props: {
    title: {
      type: String,
      default: "",
    },
    subtitle: {
      type: String,
      default: "",
    },
    info: {
      type: String,
      default: "",
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/colors.scss";

.product-banner {
  padding: 25px;
  text-align: center;
  font-family: Roboto-Regular;
  width: 100vw;
  background-color: $colorRed;
  color: white;

  &__title {
    font-size: 17px;
    line-height: 20px;
    margin-bottom: 11px;
  }

  &__subtitle {
    font-size: 12px;
    line-height: 14px;
    margin-bottom: 1px;
  }

  &__info {
    font-size: 30px;
    line-height: 35.16px;
  }
}
</style>
